require('bootstrap4-toggle')

$(function () {
    $('[data-toggle="popover"]').popover()
})
